module.exports = __webpack_public_path__ + "media/fonts/american_typewriter-webfont-eb6684610636e87a26f029a33b166909.eot";